
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12884',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12884",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.488",
  "data-fetching-client": "static-1.9825",
  "foundations-components": "static-1.8261",
  "foundations-components-legacy": "static-1.1286",
  "foundations-theming": "static-1.4606",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.84",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8188",
  "hub-http-shared-msw-handlers": "static-1.10384",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11643",
  "I18n": "static-7.1644",
  "jasmine-runner": "static-1.6623",
  "marketplace-discovery-studio-lib": "static-1.403",
  "marketplace-storefront-base": "static-1.12947",
  "quartz": "static-1.7250",
  "react-dlb": "static-1.83",
  "react-rhumb": "static-1.16867",
  "reactive-variable-buffer-atom": "static-1.3023",
  "reporting-testing-lib": "static-1.10158",
  "reselect": "static-3.7",
  "settings-ui-lib": "static-1.12686",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7442",
  "ui-addon-i18n": "static-1.11316",
  "ui-addon-react-router-dom": "static-1.9701",
  "unified-auth": "static-1.690",
  "unified-auth-core-lib": "static-1.972",
  "usage-tracker": "static-1.7519",
  "usage-tracker-core": "static-1.7369",
  "customer-data-property-utils": "static-1.8262",
  "hub-http": "static-1.6387",
  "integrations-lib": "static-1.16704",
  "marketplace-ui-common": "static-1.20318",
  "property-management-iframe": "static-1.13746",
  "quartz-config": "static-1.1028",
  "quartz-core": "static-1.6469",
  "quartz-routing": "static-1.680",
  "quick-fetch": "static-1.4037",
  "react": "static-7.189",
  "rpc-client-utils": "static-1.4825",
  "ts-schema": "static-1.4201",
  "ui-universal-auth": "static-1.9176",
  "UIComponents": "static-3.8589",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3521",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3527",
  "quartz-webpack": "static-1.3474",
  "bend-plugin-quartz-routing": "static-1.328",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4530",
  "floating-ui": "static-1.59",
  "foundations-assets": "static-1.5041",
  "foundations-theming-specialty": "static-1.2322",
  "framer-motion": "static-1.74",
  "hs-story-utils": "static-1.9592",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.43",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5461",
  "react-virtualized": "static-2.101",
  "StyleGuideUI": "static-3.490",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2271",
  "ui-fonts": "static-1.905",
  "ui-images": "static-2.1204",
  "bend-plugin-foundations-theming": "static-1.3089",
  "foundations-theming-base": "static-1.3591",
  "stylex": "static-1.36",
  "HeadJS": "static-2.776",
  "hs-test-utils-bend-plugin": "static-1.3299",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4491",
  "ui-addon-video-player": "static-1.8872",
  "ai-components-ui-library": "static-1.9386",
  "ai-rendering-library": "static-1.10773",
  "chirp-fetch": "static-1.2055",
  "connections-embed-lib": "static-1.1314",
  "copilot-toolkit": "static-1.11572",
  "feedback-loader": "static-1.29615",
  "laboratory-lib": "static-3.7319",
  "marketplace-embed": "static-1.22613",
  "marketplace-ui-details": "static-1.10213",
  "marketplace-ui-reviews": "static-1.20273",
  "marketplace-ui-tracking": "static-1.14488",
  "sanitize-text": "static-1.8313",
  "usage-tracker-multi": "static-1.5933",
  "usage-tracker-session-replay": "static-1.5205",
  "wootric-nps": "static-1.7104",
  "quartz-head": "static-1.915",
  "web-vitals": "static-1.8",
  "apollo-link-hub-http": "static-2.4818",
  "immer": "static-1.33",
  "immerable": "static-1.4317",
  "highcharts": "static-8.106",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2599",
  "reporting-data": "static-1.68225",
  "cssUtils": "static-1.841",
  "flux-actions": "static-1.351",
  "HubStyle": "static-2.11950",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10374",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10531",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7509",
  "icons": "static-2.664",
  "marketplace-ui-apps-core": "static-1.18850",
  "storybook-react": "static-1.35",
  "trellis-story-utils": "static-1.4674",
  "foundations-components-test-utils": "static-1.5744",
  "quartz-i18n": "static-1.925",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.185",
  "ads-unified-auth-lib": "static-1.668",
  "google-sheets-integration-lib": "static-1.749",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.201",
  "slack-ui-library": "static-1.10564",
  "fsm": "static-1.3897",
  "customer-data-objects": "static-1.7846",
  "property-translator": "static-1.5561",
  "hs-locale-management": "static-1.202",
  "frontend-preferences-client": "static-1.8095",
  "hs-promise-utils": "static-1.5761",
  "hubspot-apollo-client": "static-1.5046",
  "integrations-error-boundary-lib": "static-1.14119",
  "integrations-tracking-lib": "static-1.5773",
  "native-integrations-shared-strings": "static-1.7947",
  "sanitize": "static-1.4644",
  "superstore": "static-1.4926",
  "ui-shepherd-react": "static-3.10429",
  "ai-settings-ui-library": "static-1.8147",
  "hub-http-janus": "static-1.851",
  "hubspotter-http": "static-1.4771",
  "immutable-less": "static-1.4817",
  "marketplace-ui-client-types": "static-1.17725",
  "nav-meta": "static-1.30112",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18214",
  "inbound-db-properties-service-client": "static-1.3967",
  "property-management-common": "static-1.6034",
  "ui-addon-iframeable": "static-1.9244",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.550",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.925",
  "quartz-test": "static-1.925",
  "quartz-tracking": "static-1.629",
  "trellis-components": "static-1.2290",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.235",
  "bender-build-tools": "static-1.3301",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22159",
  "ContentUtils": "static-1.68872",
  "customer-data-objects-ui-components": "static-1.13197",
  "sassPrefix": "static-1.159",
  "avatar-components": "static-1.2666",
  "breeze-engine-core": "static-1.605",
  "breeze-onboarding-components": "static-1.423",
  "customer-data-filters-ui": "static-1.40430",
  "customer-data-reference-ui-components": "static-1.13343",
  "embedded-academy-lib": "static-1.14962",
  "ExportDialog": "static-6.10546",
  "highlight.js": "static-1.81",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41740",
  "reporting-snowflake": "static-1.56843",
  "reporting-ui-components": "static-2.65496",
  "reporting-visualizations": "static-1.60301",
  "trellis-theming": "static-1.1115",
  "ui-addon-teams": "static-1.21761",
  "integrations-reconnect-lib": "static-1.287",
  "magpie-lib": "static-1.5663",
  "navigation-components": "static-1.18475",
  "breeze-engine-lib": "static-1.1327",
  "magpie-types": "static-1.5123",
  "simple-logging-lib": "static-1.3217",
  "ai-studio-lib": "static-1.12121",
  "app-governance-lib": "static-1.2091",
  "developer-experience-shared-components": "static-1.10703",
  "hubspot-prosemirror": "static-1.18731",
  "purchase-motions-components": "static-1.6161",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8187",
  "ui-product-approvals": "static-1.28790",
  "ui-tool-access": "static-1.10320",
  "usage-based-billing-components-lib": "static-1.9663",
  "usage-tracker-anonymous": "static-1.5936",
  "usage-tracker-public": "static-1.7330",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3708",
  "persist-promise": "static-1.3868",
  "reference-resolvers": "static-1.8343",
  "ui-extensibility-client-types": "static-1.4091",
  "hubspot-apollo-cache": "static-1.505",
  "universal-page-editor-lib": "static-1.3180",
  "final-form": "static-1.72",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3266",
  "atom": "static-1.5242",
  "merchandise-lib": "static-1.266",
  "salesImages": "static-1.528",
  "batch-promise": "static-1.1711",
  "crm-component-utils": "static-1.39555",
  "crm-properties-common-lib": "static-1.6055",
  "customer-data-properties": "static-1.52152",
  "framework-data-schema-resolvers": "static-1.7061",
  "property-value-citations": "static-1.2766",
  "reference-resolvers-lite": "static-1.8264",
  "ui-business-units-lib": "static-1.9246",
  "navigation-messaging": "static-1.7802",
  "hubspotter-http-shared-msw-handlers": "static-1.10382",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "tanstack-virtual": "static-1.32",
  "cms-field-types": "static-1.4982",
  "content-icons-ui": "static-1.2277",
  "customer-data-ui-utilities": "static-1.9991",
  "conversations-skeleton-state": "static-1.7414",
  "crm-message-bus": "static-1.43471",
  "customer-data-filters-ui-msw-helpers": "static-1.22865",
  "events-data-lib": "static-1.405",
  "FormUrlGenerator": "static-2.4888",
  "framework-builder-read-service-client": "static-1.4126",
  "framework-data-schema-quick-fetch": "static-1.6966",
  "multi-account-reference-resolvers": "static-1.1151",
  "onboarding-tours": "static-1.16923",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14176",
  "academy-common-lib": "static-1.14422",
  "content-assistance-lib": "static-1.8014",
  "dashboard-lib": "static-1.82206",
  "file-manager-components": "static-1.24125",
  "getting-started-shared-tasks": "static-1.18920",
  "hubspot-prosemirror-plugins": "static-1.18723",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20126",
  "share-with-third-party-component-lib": "static-1.8873",
  "ui-addon-draggable": "static-3.4925",
  "ui-asset-management-lib": "static-1.11249",
  "user-context": "static-1.5277",
  "growth-payments-core": "static-1.25896",
  "reporting-plugins": "static-1.10589",
  "reporting-reports": "static-1.67903",
  "idb-keyval": "static-1.46",
  "reactive-lib": "static-1.891",
  "nest": "static-1.401",
  "ably": "static-2.2",
  "codemirror": "static-5.97",
  "react-codemirror": "static-1.10799",
  "framework-listing-lib": "static-2.29192",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31102",
  "apps-service-types": "static-1.3968",
  "oauth-service-types": "static-1.4421",
  "content-media-capture": "static-1.5068",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8584",
  "payment-link-components": "static-1.23899",
  "ui-addon-emoji-picker": "static-1.10051",
  "video-components-external": "static-1.11844",
  "video-data-lib": "static-1.35502",
  "onboarding-scopes": "static-1.6626",
  "purchase-motions-api": "static-1.6164",
  "signup-constants": "static-1.19289",
  "signup-ui-url-generator": "static-2.8225",
  "react-dnd-compat": "static-1.4782",
  "ui-product-approvals-common": "static-1.685",
  "onboarding-tours-client": "static-1.5137",
  "platform-infra-nav-components": "static-1.7795",
  "subscription-experience-data-types": "static-1.15123",
  "crm-record-cards-service-types": "static-1.3705",
  "location-customization-utils-lib": "static-1.9762",
  "redux-thunk": "static-2.43",
  "card-properties-lib": "static-1.44722",
  "commerce-subscription-lib": "static-1.37580",
  "crm-actions": "static-1.6512",
  "crm-cards-sdk": "static-1.44120",
  "customer-data-properties-shared-msw-handlers": "static-1.9711",
  "customer-data-tracking": "static-1.7051",
  "hs-resources": "static-1.346",
  "pulse": "static-1.778",
  "calling-global-api": "static-1.65103",
  "calling-internal-common": "static-1.31480",
  "calling-lifecycle-internal": "static-1.66485",
  "calling-lifecycle-messages": "static-1.58779",
  "commerce-products-lib": "static-1.10199",
  "conditional-properties-service-client": "static-1.3918",
  "crm-links": "static-1.6482",
  "crm-pipelines-api-client-types": "static-1.4258",
  "external-options-client-types": "static-1.4247",
  "formula-editor": "static-1.14557",
  "google-libphonenumber": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4338",
  "meetings-icalendar-utils-lib": "static-1.800",
  "multi-currency-client-types": "static-1.3812",
  "object-builder-ui-client": "static-1.49305",
  "pipeline-validation-client-types": "static-1.4087",
  "smart-property-lib": "static-1.8047",
  "tiered-pricing": "static-1.1691",
  "topics-actions-lib": "static-1.306",
  "ui-addon-form-validation": "static-1.11157",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.180",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1349",
  "growth-data-modal": "static-1.5706",
  "growth-onboarding-confetti": "static-1.3232",
  "growth-onboarding-next-action-utils": "static-1.2423",
  "onboarding-tours-utils": "static-1.989",
  "ui-shepherd-tracker": "static-1.7810",
  "academy-service-client": "static-1.3852",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39624",
  "FileManagerLib": "static-1.39765",
  "SafeStorage": "static-1.4567",
  "video-embed": "static-1.36336",
  "ui-coaching-tips": "static-1.29041",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24749",
  "viral-links-lib": "static-1.7239",
  "data-token-picker": "static-1.16709",
  "react-flip-move": "static-1.73",
  "nested-table": "static-1.405",
  "timezone-utils": "static-2.5410",
  "seat-types-lib": "static-1.396",
  "getting-started-shared-tasks-store": "static-1.18038",
  "ui-addon-opt": "static-4.8528",
  "campaign-roi-lib": "static-1.9703",
  "ui-addon-calendars": "static-2.5489",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25795",
  "framework-data-table": "static-2.12306",
  "marketing-platform-lib": "static-1.7034",
  "nudge-client-utils": "static-1.2945",
  "nudge-custom-ui-functions": "static-1.1314",
  "switchboard-lib": "static-1.392",
  "app-users-service-client": "static-1.5783",
  "app-users-service-types": "static-1.5191",
  "mini-checkout-client": "static-1.27250",
  "onboarding-utils": "static-1.5527",
  "permissions-shared-i18n-strings-fe": "static-1.2073",
  "ui-coaching-tips-shared-config": "static-1.29026",
  "content-media-composition-data-lib": "static-1.12872",
  "fix-webm-duration": "static-1.25",
  "notification-sounds": "static-1.4592",
  "commerce-tours-lib": "static-1.6422",
  "growth-onboarding-reliability": "static-1.5250",
  "sales-checkout-service-client": "static-1.3742",
  "content-media-compositions": "static-2.16879",
  "media-bridge-lib": "static-1.19224",
  "edison-service-client-types": "static-1.554",
  "crm_data": "static-4.92500",
  "customer-data-sidebar": "static-2.46486",
  "enrichment-properties-lib": "static-1.17295",
  "ui-addon-draggable-compat": "static-2.4426",
  "universal-record-utils-lib": "static-1.1439",
  "commerce-billing-lib": "static-1.19660",
  "commerce-shared-components-lib": "static-1.18966",
  "commerce-tools-ui-lib": "static-1.10816",
  "crm-fe-perf": "static-1.23066",
  "event-emitter": "static-1.1117",
  "bend-plugin-pulse": "static-1.281",
  "fast-json-patch": "static-1.65",
  "calling-error-reporting": "static-1.31487",
  "shared-worker-versioning": "static-1.11203",
  "calling-usage-tracker": "static-1.6708",
  "voice-sms-access-library": "static-1.1616",
  "commerce-permissions": "static-1.942",
  "products-iframe-lib": "static-1.8346",
  "products-ui-components-shared-msw-handlers": "static-1.10766",
  "bark-lib": "static-1.16641",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.463",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10467",
  "policy-lib": "static-1.6952",
  "react-tinymce": "static-1.55704",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10530",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54830",
  "tinymce-plugins": "static-1.57944",
  "tinymce-themes": "static-1.56800",
  "onboarding-data-sync-lib": "static-1.2254",
  "growth-onboarding-next-action-components": "static-1.2451",
  "user-context-client": "static-1.4718",
  "audio-components": "static-1.6171",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37276",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4699",
  "video-components": "static-1.13846",
  "outpost": "static-1.4335",
  "growth-onboarding-feedback-components": "static-1.6746",
  "draft-convert": "static-2.75",
  "draft-extend": "static-3.78",
  "draft-js": "static-5.80",
  "draft-plugins": "static-2.21973",
  "sales-email-signature-service-client": "static-1.4014",
  "ts-utils-lib": "static-1.340",
  "crm-export-dialog": "static-1.6451",
  "crm-index-associations-lib": "static-1.6607",
  "crm-view-components": "static-1.802",
  "react-beautiful-dnd": "static-1.65",
  "customer-data-associations": "static-1.7499",
  "nudge-custom-function-registry": "static-1.2702",
  "nudge-renderer-utils": "static-1.3021",
  "whisper-core-api": "static-1.7041",
  "InboxConnectUtils": "static-4.15277",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5961",
  "settings-content-modals": "static-1.46572",
  "js-cookie": "static-1.18",
  "crm_universal": "static-1.22311",
  "customer-data-email": "static-1.18346",
  "card-payment-highlight-lib": "static-1.37677",
  "card-subscription-highlight-lib": "static-1.40003",
  "commerce-contract-lib": "static-1.12867",
  "invoices-highlight-card-lib": "static-1.55292",
  "orders-highlight-card-lib": "static-1.21942",
  "products-highlight-card-lib": "static-1.18482",
  "quotes-highlight-card-lib": "static-1.72577",
  "crm-source-interpretation-lib": "static-1.5500",
  "crm-object-search-query-utilities": "static-1.9963",
  "utility-belt": "static-1.2699",
  "payments-enrollment-embed-lib": "static-1.23493",
  "stripe-embedded-components": "static-1.7812",
  "customer-data-rte": "static-1.33422",
  "cv-backend-services": "static-1.1584",
  "growth-onboarding-empty-states": "static-1.6068",
  "payments-post-enroll-local-storage-lib": "static-1.5272",
  "qrcode-generator": "static-1.71",
  "quotes-client-types": "static-1.38667",
  "trials-service-types": "static-1.4050",
  "calling-orchestration-schema": "static-1.36393",
  "sales-views-client-types": "static-1.4425",
  "react-reducer-toolkit": "static-1.16075",
  "hub-http-contrib": "static-1.3210",
  "interframe": "static-3.4923",
  "tinymce-data": "static-1.40915",
  "ui-addon-sales-email": "static-1.5379",
  "layout-dnd-components": "static-1.12773",
  "layout-dnd-utils": "static-1.11748",
  "ui-brand-identity-lib": "static-1.15903",
  "NamespacedHubStyle": "static-2.9174",
  "meetings-connect-utils-lib": "static-1.7774",
  "social-insights-client-types": "static-1.22528",
  "crm-index-visualization-core": "static-1.4354",
  "checkout-sdk": "static-3.24093",
  "company-details-components": "static-1.6365",
  "payment-method-components": "static-1.7021",
  "pricing-pages-ui-components": "static-1.14970",
  "quote-checkout-service-types": "static-1.3626",
  "upgrade-catalog-service-types": "static-1.3685",
  "access-control-lib": "static-1.10604",
  "EmailComponents": "static-1.55262",
  "EmailData": "static-1.53939",
  "redux-less": "static-2.9647",
  "sequences-lib": "static-1.8339",
  "ui-gdpr-components": "static-1.10517",
  "products-ui-components": "static-1.40717",
  "accounting-integrations-ui-components": "static-1.7345",
  "invoices-ui-lib": "static-1.55308",
  "commerce-products-api": "static-1.2542",
  "invoices-iframe-lib": "static-1.57366",
  "quotes-modal-lib": "static-1.103255",
  "quotes-ui-lib": "static-1.81298",
  "stripe-connect-js": "static-1.72",
  "draft-content-plugins": "static-1.28689",
  "ContentData": "static-1.68947",
  "layout-data-lib": "static-1.10073",
  "hub-http-rxjs": "static-1.817",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4103",
  "billing-payments-client-types": "static-1.4155",
  "react-performance-metrics-lib": "static-1.722",
  "pricing-pages-api": "static-1.14835",
  "ContentComponents": "static-2.71828",
  "marketing-contacts-lib": "static-1.10659",
  "marketing-email-service-types": "static-1.2026",
  "messaging-editing-lib": "static-1.46812",
  "messaging-usage-based-billing-components-lib": "static-1.1674",
  "automation-ui-source-apps": "static-1.19385",
  "automation-ui-types": "static-1.20303",
  "messaging-types-lib": "static-1.46549",
  "onboarding-settings-client": "static-1.4671",
  "sequences-client-types-lib": "static-1.8196",
  "commerce-tax-lib": "static-1.705",
  "price-books-api": "static-1.1415",
  "price-books-components": "static-1.1473",
  "property-description-translator": "static-1.4005",
  "ramp-editor": "static-1.625",
  "commerce-analytics-service-client": "static-1.3730",
  "totals-ui-components": "static-1.24058",
  "SalesContentIndexUI": "static-3.9480",
  "advanced-menus-core": "static-1.15410",
  "advanced-menus-lib": "static-1.12307",
  "ui-memberships-settings-lib": "static-1.34515",
  "segments-query-core": "static-1.1587",
  "automation-ui-ubb": "static-1.6219",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7504",
  "data-token-views": "static-1.16690",
  "forms-utils-lib": "static-1.12895",
  "payments-embed-points-lib": "static-1.13385",
  "simple-menus-core": "static-1.15409",
  "simple-menus-lib": "static-1.16926",
  "videoconference-integration-components": "static-1.7068",
  "marketing-contacts-client": "static-1.7675",
  "mc-hard-limits-client-types": "static-1.66",
  "automation-applications-service-types": "static-1.3624",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77594",
  "short-messages-app-service-client": "static-1.4086",
  "web-interactives-components": "static-1.14055",
  "web-interactives-data": "static-1.14056",
  "messaging-shared-utils-lib": "static-1.1123",
  "messaging-user-info-utils-lib": "static-1.1293",
  "email-portal-health-service-types": "static-1.1143",
  "line-items-api": "static-1.939",
  "commerce-totals-service-types": "static-1.3937",
  "FireAlarmUi": "static-1.4629",
  "sales-templates-service-types-lib": "static-1.4290",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22239",
  "automation-ui-usage-tracking": "static-1.21702",
  "data-studio-ubb": "static-1.3220",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27413",
  "collaboration-sidebar": "static-1.58389",
  "content-management-data-lib": "static-1.5737",
  "copilot-plugins": "static-1.11545",
  "cta-picker": "static-1.36839",
  "customer-agent-discovery-components-lib": "static-1.3561",
  "editor-components": "static-1.13475",
  "editor-iframe-lib": "static-1.8636",
  "error-messaging-js": "static-1.5363",
  "FormsCommonComponents": "static-1.86300",
  "pictos": "static-7.187",
  "react-transition-group": "static-2.67",
  "redux-request-state": "static-1.10813",
  "SharedLegalStrings": "static-1.1911",
  "smart-content-core": "static-1.42914",
  "smart-content-lib": "static-1.43567",
  "social-composer-lib": "static-1.59776",
  "structured-content-lib": "static-1.25657",
  "theme-previewer-lib": "static-1.53707",
  "tinymce-copilot": "static-1.16898",
  "xray-recommendation-lib": "static-1.8115",
  "automation-ui-routing": "static-1.21660",
  "sql-reporting-client-types": "static-1.5776",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42564",
  "campaigns-utils-lib": "static-1.3360",
  "reporting-enablement": "static-1.23496",
  "chatspot-widget-iframe": "static-1.22150",
  "collaboration-sidebar-common": "static-1.3186",
  "forms-ai-lib": "static-1.4580",
  "codemirror-dlb": "static-1.59153",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6602",
  "report-customization-components": "static-1.13624",
  "data-quality-ui-library": "static-1.13476",
  "reporting-filters": "static-1.749",
  "reporting-insights-lib": "static-1.2267"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12884",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.488",
  "data-fetching-client": "/data-fetching-client/static-1.9825",
  "foundations-components": "/foundations-components/static-1.8261",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1286",
  "foundations-theming": "/foundations-theming/static-1.4606",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.84",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8188",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10384",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11643",
  "I18n": "/I18n/static-7.1644",
  "jasmine-runner": "/jasmine-runner/static-1.6623",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.403",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12947",
  "quartz": "/quartz/static-1.7250",
  "react-dlb": "/react-dlb/static-1.83",
  "react-rhumb": "/react-rhumb/static-1.16867",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3023",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10158",
  "reselect": "/reselect/static-3.7",
  "settings-ui-lib": "/settings-ui-lib/static-1.12686",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7442",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11316",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9701",
  "unified-auth": "/unified-auth/static-1.690",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.972",
  "usage-tracker": "/usage-tracker/static-1.7519",
  "usage-tracker-core": "/usage-tracker-core/static-1.7369",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8262",
  "hub-http": "/hub-http/static-1.6387",
  "integrations-lib": "/integrations-lib/static-1.16704",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20318",
  "property-management-iframe": "/property-management-iframe/static-1.13746",
  "quartz-config": "/quartz-config/static-1.1028",
  "quartz-core": "/quartz-core/static-1.6469",
  "quartz-routing": "/quartz-routing/static-1.680",
  "quick-fetch": "/quick-fetch/static-1.4037",
  "react": "/react/static-7.189",
  "rpc-client-utils": "/rpc-client-utils/static-1.4825",
  "ts-schema": "/ts-schema/static-1.4201",
  "ui-universal-auth": "/ui-universal-auth/static-1.9176",
  "UIComponents": "/UIComponents/static-3.8589",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3521",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3527",
  "quartz-webpack": "/quartz-webpack/static-1.3474",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.328",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4530",
  "floating-ui": "/floating-ui/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.5041",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2322",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-story-utils": "/hs-story-utils/static-1.9592",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.43",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5461",
  "react-virtualized": "/react-virtualized/static-2.101",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2271",
  "ui-fonts": "/ui-fonts/static-1.905",
  "ui-images": "/ui-images/static-2.1204",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3089",
  "foundations-theming-base": "/foundations-theming-base/static-1.3591",
  "stylex": "/stylex/static-1.36",
  "HeadJS": "/HeadJS/static-2.776",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3299",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4491",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8872",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9386",
  "ai-rendering-library": "/ai-rendering-library/static-1.10773",
  "chirp-fetch": "/chirp-fetch/static-1.2055",
  "connections-embed-lib": "/connections-embed-lib/static-1.1314",
  "copilot-toolkit": "/copilot-toolkit/static-1.11572",
  "feedback-loader": "/feedback-loader/static-1.29615",
  "laboratory-lib": "/laboratory-lib/static-3.7319",
  "marketplace-embed": "/marketplace-embed/static-1.22613",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10213",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20273",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14488",
  "sanitize-text": "/sanitize-text/static-1.8313",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5933",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5205",
  "wootric-nps": "/wootric-nps/static-1.7104",
  "quartz-head": "/quartz-head/static-1.915",
  "web-vitals": "/web-vitals/static-1.8",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4818",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4317",
  "highcharts": "/highcharts/static-8.106",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2599",
  "reporting-data": "/reporting-data/static-1.68225",
  "cssUtils": "/cssUtils/static-1.841",
  "flux-actions": "/flux-actions/static-1.351",
  "HubStyle": "/HubStyle/static-2.11950",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10374",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10531",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7509",
  "icons": "/icons/static-2.664",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18850",
  "storybook-react": "/storybook-react/static-1.35",
  "trellis-story-utils": "/trellis-story-utils/static-1.4674",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5744",
  "quartz-i18n": "/quartz-i18n/static-1.925",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.185",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.668",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.749",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.201",
  "slack-ui-library": "/slack-ui-library/static-1.10564",
  "fsm": "/fsm/static-1.3897",
  "customer-data-objects": "/customer-data-objects/static-1.7846",
  "property-translator": "/property-translator/static-1.5561",
  "hs-locale-management": "/hs-locale-management/static-1.202",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8095",
  "hs-promise-utils": "/hs-promise-utils/static-1.5761",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5046",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14119",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5773",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7947",
  "sanitize": "/sanitize/static-1.4644",
  "superstore": "/superstore/static-1.4926",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10429",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8147",
  "hub-http-janus": "/hub-http-janus/static-1.851",
  "hubspotter-http": "/hubspotter-http/static-1.4771",
  "immutable-less": "/immutable-less/static-1.4817",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17725",
  "nav-meta": "/nav-meta/static-1.30112",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18214",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3967",
  "property-management-common": "/property-management-common/static-1.6034",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9244",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.550",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.925",
  "quartz-test": "/quartz-test/static-1.925",
  "quartz-tracking": "/quartz-tracking/static-1.629",
  "trellis-components": "/trellis-components/static-1.2290",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.235",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22159",
  "ContentUtils": "/ContentUtils/static-1.68872",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13197",
  "sassPrefix": "/sassPrefix/static-1.159",
  "avatar-components": "/avatar-components/static-1.2666",
  "breeze-engine-core": "/breeze-engine-core/static-1.605",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.423",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40430",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13343",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14962",
  "ExportDialog": "/ExportDialog/static-6.10546",
  "highlight.js": "/highlight.js/static-1.81",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41740",
  "reporting-snowflake": "/reporting-snowflake/static-1.56843",
  "reporting-ui-components": "/reporting-ui-components/static-2.65496",
  "reporting-visualizations": "/reporting-visualizations/static-1.60301",
  "trellis-theming": "/trellis-theming/static-1.1115",
  "ui-addon-teams": "/ui-addon-teams/static-1.21761",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.287",
  "magpie-lib": "/magpie-lib/static-1.5663",
  "navigation-components": "/navigation-components/static-1.18475",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1327",
  "magpie-types": "/magpie-types/static-1.5123",
  "simple-logging-lib": "/simple-logging-lib/static-1.3217",
  "ai-studio-lib": "/ai-studio-lib/static-1.12121",
  "app-governance-lib": "/app-governance-lib/static-1.2091",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10703",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18731",
  "purchase-motions-components": "/purchase-motions-components/static-1.6161",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8187",
  "ui-product-approvals": "/ui-product-approvals/static-1.28790",
  "ui-tool-access": "/ui-tool-access/static-1.10320",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9663",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5936",
  "usage-tracker-public": "/usage-tracker-public/static-1.7330",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3708",
  "persist-promise": "/persist-promise/static-1.3868",
  "reference-resolvers": "/reference-resolvers/static-1.8343",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4091",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.505",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3180",
  "final-form": "/final-form/static-1.72",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3266",
  "atom": "/atom/static-1.5242",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "salesImages": "/salesImages/static-1.528",
  "batch-promise": "/batch-promise/static-1.1711",
  "crm-component-utils": "/crm-component-utils/static-1.39555",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6055",
  "customer-data-properties": "/customer-data-properties/static-1.52152",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7061",
  "property-value-citations": "/property-value-citations/static-1.2766",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8264",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9246",
  "navigation-messaging": "/navigation-messaging/static-1.7802",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10382",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "cms-field-types": "/cms-field-types/static-1.4982",
  "content-icons-ui": "/content-icons-ui/static-1.2277",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9991",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7414",
  "crm-message-bus": "/crm-message-bus/static-1.43471",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22865",
  "events-data-lib": "/events-data-lib/static-1.405",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4888",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4126",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6966",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1151",
  "onboarding-tours": "/onboarding-tours/static-1.16923",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14176",
  "academy-common-lib": "/academy-common-lib/static-1.14422",
  "content-assistance-lib": "/content-assistance-lib/static-1.8014",
  "dashboard-lib": "/dashboard-lib/static-1.82206",
  "file-manager-components": "/file-manager-components/static-1.24125",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18920",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18723",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20126",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8873",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4925",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11249",
  "user-context": "/user-context/static-1.5277",
  "growth-payments-core": "/growth-payments-core/static-1.25896",
  "reporting-plugins": "/reporting-plugins/static-1.10589",
  "reporting-reports": "/reporting-reports/static-1.67903",
  "idb-keyval": "/idb-keyval/static-1.46",
  "reactive-lib": "/reactive-lib/static-1.891",
  "nest": "/nest/static-1.401",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.97",
  "react-codemirror": "/react-codemirror/static-1.10799",
  "framework-listing-lib": "/framework-listing-lib/static-2.29192",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31102",
  "apps-service-types": "/apps-service-types/static-1.3968",
  "oauth-service-types": "/oauth-service-types/static-1.4421",
  "content-media-capture": "/content-media-capture/static-1.5068",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "payment-link-components": "/payment-link-components/static-1.23899",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10051",
  "video-components-external": "/video-components-external/static-1.11844",
  "video-data-lib": "/video-data-lib/static-1.35502",
  "onboarding-scopes": "/onboarding-scopes/static-1.6626",
  "purchase-motions-api": "/purchase-motions-api/static-1.6164",
  "signup-constants": "/signup-constants/static-1.19289",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8225",
  "react-dnd-compat": "/react-dnd-compat/static-1.4782",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.685",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5137",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7795",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15123",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3705",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9762",
  "redux-thunk": "/redux-thunk/static-2.43",
  "card-properties-lib": "/card-properties-lib/static-1.44722",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37580",
  "crm-actions": "/crm-actions/static-1.6512",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44120",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9711",
  "customer-data-tracking": "/customer-data-tracking/static-1.7051",
  "hs-resources": "/hs-resources/static-1.346",
  "pulse": "/pulse/static-1.778",
  "calling-global-api": "/calling-global-api/static-1.65103",
  "calling-internal-common": "/calling-internal-common/static-1.31480",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66485",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58779",
  "commerce-products-lib": "/commerce-products-lib/static-1.10199",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3918",
  "crm-links": "/crm-links/static-1.6482",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4258",
  "external-options-client-types": "/external-options-client-types/static-1.4247",
  "formula-editor": "/formula-editor/static-1.14557",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4338",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.800",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3812",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49305",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4087",
  "smart-property-lib": "/smart-property-lib/static-1.8047",
  "tiered-pricing": "/tiered-pricing/static-1.1691",
  "topics-actions-lib": "/topics-actions-lib/static-1.306",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11157",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.180",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1349",
  "growth-data-modal": "/growth-data-modal/static-1.5706",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3232",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2423",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.989",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7810",
  "academy-service-client": "/academy-service-client/static-1.3852",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39624",
  "FileManagerLib": "/FileManagerLib/static-1.39765",
  "SafeStorage": "/SafeStorage/static-1.4567",
  "video-embed": "/video-embed/static-1.36336",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29041",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24749",
  "viral-links-lib": "/viral-links-lib/static-1.7239",
  "data-token-picker": "/data-token-picker/static-1.16709",
  "react-flip-move": "/react-flip-move/static-1.73",
  "nested-table": "/nested-table/static-1.405",
  "timezone-utils": "/timezone-utils/static-2.5410",
  "seat-types-lib": "/seat-types-lib/static-1.396",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18038",
  "ui-addon-opt": "/ui-addon-opt/static-4.8528",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9703",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5489",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25795",
  "framework-data-table": "/framework-data-table/static-2.12306",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7034",
  "nudge-client-utils": "/nudge-client-utils/static-1.2945",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1314",
  "switchboard-lib": "/switchboard-lib/static-1.392",
  "app-users-service-client": "/app-users-service-client/static-1.5783",
  "app-users-service-types": "/app-users-service-types/static-1.5191",
  "mini-checkout-client": "/mini-checkout-client/static-1.27250",
  "onboarding-utils": "/onboarding-utils/static-1.5527",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2073",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29026",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12872",
  "fix-webm-duration": "/fix-webm-duration/static-1.25",
  "notification-sounds": "/notification-sounds/static-1.4592",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6422",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5250",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3742",
  "content-media-compositions": "/content-media-compositions/static-2.16879",
  "media-bridge-lib": "/media-bridge-lib/static-1.19224",
  "edison-service-client-types": "/edison-service-client-types/static-1.554",
  "crm_data": "/crm_data/static-4.92500",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46486",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17295",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4426",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1439",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19660",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18966",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10816",
  "crm-fe-perf": "/crm-fe-perf/static-1.23066",
  "event-emitter": "/event-emitter/static-1.1117",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.281",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "calling-error-reporting": "/calling-error-reporting/static-1.31487",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11203",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6708",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1616",
  "commerce-permissions": "/commerce-permissions/static-1.942",
  "products-iframe-lib": "/products-iframe-lib/static-1.8346",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10766",
  "bark-lib": "/bark-lib/static-1.16641",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.463",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10467",
  "policy-lib": "/policy-lib/static-1.6952",
  "react-tinymce": "/react-tinymce/static-1.55704",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10530",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54830",
  "tinymce-plugins": "/tinymce-plugins/static-1.57944",
  "tinymce-themes": "/tinymce-themes/static-1.56800",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2254",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2451",
  "user-context-client": "/user-context-client/static-1.4718",
  "audio-components": "/audio-components/static-1.6171",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37276",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4699",
  "video-components": "/video-components/static-1.13846",
  "outpost": "/outpost/static-1.4335",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6746",
  "draft-convert": "/draft-convert/static-2.75",
  "draft-extend": "/draft-extend/static-3.78",
  "draft-js": "/draft-js/static-5.80",
  "draft-plugins": "/draft-plugins/static-2.21973",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4014",
  "ts-utils-lib": "/ts-utils-lib/static-1.340",
  "crm-export-dialog": "/crm-export-dialog/static-1.6451",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6607",
  "crm-view-components": "/crm-view-components/static-1.802",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.65",
  "customer-data-associations": "/customer-data-associations/static-1.7499",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2702",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3021",
  "whisper-core-api": "/whisper-core-api/static-1.7041",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15277",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5961",
  "settings-content-modals": "/settings-content-modals/static-1.46572",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_universal": "/crm_universal/static-1.22311",
  "customer-data-email": "/customer-data-email/static-1.18346",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37677",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40003",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12867",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55292",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21942",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18482",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72577",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5500",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9963",
  "utility-belt": "/utility-belt/static-1.2699",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23493",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7812",
  "customer-data-rte": "/customer-data-rte/static-1.33422",
  "cv-backend-services": "/cv-backend-services/static-1.1584",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6068",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5272",
  "qrcode-generator": "/qrcode-generator/static-1.71",
  "quotes-client-types": "/quotes-client-types/static-1.38667",
  "trials-service-types": "/trials-service-types/static-1.4050",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36393",
  "sales-views-client-types": "/sales-views-client-types/static-1.4425",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16075",
  "hub-http-contrib": "/hub-http-contrib/static-1.3210",
  "interframe": "/interframe/static-3.4923",
  "tinymce-data": "/tinymce-data/static-1.40915",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5379",
  "layout-dnd-components": "/layout-dnd-components/static-1.12773",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11748",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15903",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9174",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7774",
  "social-insights-client-types": "/social-insights-client-types/static-1.22528",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4354",
  "checkout-sdk": "/checkout-sdk/static-3.24093",
  "company-details-components": "/company-details-components/static-1.6365",
  "payment-method-components": "/payment-method-components/static-1.7021",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14970",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3626",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3685",
  "access-control-lib": "/access-control-lib/static-1.10604",
  "EmailComponents": "/EmailComponents/static-1.55262",
  "EmailData": "/EmailData/static-1.53939",
  "redux-less": "/redux-less/static-2.9647",
  "sequences-lib": "/sequences-lib/static-1.8339",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10517",
  "products-ui-components": "/products-ui-components/static-1.40717",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7345",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55308",
  "commerce-products-api": "/commerce-products-api/static-1.2542",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57366",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103255",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81298",
  "stripe-connect-js": "/stripe-connect-js/static-1.72",
  "draft-content-plugins": "/draft-content-plugins/static-1.28689",
  "ContentData": "/ContentData/static-1.68947",
  "layout-data-lib": "/layout-data-lib/static-1.10073",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.817",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4103",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4155",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.722",
  "pricing-pages-api": "/pricing-pages-api/static-1.14835",
  "ContentComponents": "/ContentComponents/static-2.71828",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10659",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2026",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46812",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1674",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19385",
  "automation-ui-types": "/automation-ui-types/static-1.20303",
  "messaging-types-lib": "/messaging-types-lib/static-1.46549",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4671",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8196",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.705",
  "price-books-api": "/price-books-api/static-1.1415",
  "price-books-components": "/price-books-components/static-1.1473",
  "property-description-translator": "/property-description-translator/static-1.4005",
  "ramp-editor": "/ramp-editor/static-1.625",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3730",
  "totals-ui-components": "/totals-ui-components/static-1.24058",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9480",
  "advanced-menus-core": "/advanced-menus-core/static-1.15410",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12307",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34515",
  "segments-query-core": "/segments-query-core/static-1.1587",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6219",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7504",
  "data-token-views": "/data-token-views/static-1.16690",
  "forms-utils-lib": "/forms-utils-lib/static-1.12895",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13385",
  "simple-menus-core": "/simple-menus-core/static-1.15409",
  "simple-menus-lib": "/simple-menus-lib/static-1.16926",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7068",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7675",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.66",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3624",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77594",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4086",
  "web-interactives-components": "/web-interactives-components/static-1.14055",
  "web-interactives-data": "/web-interactives-data/static-1.14056",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1123",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1293",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1143",
  "line-items-api": "/line-items-api/static-1.939",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3937",
  "FireAlarmUi": "/FireAlarmUi/static-1.4629",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4290",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22239",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21702",
  "data-studio-ubb": "/data-studio-ubb/static-1.3220",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27413",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58389",
  "content-management-data-lib": "/content-management-data-lib/static-1.5737",
  "copilot-plugins": "/copilot-plugins/static-1.11545",
  "cta-picker": "/cta-picker/static-1.36839",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3561",
  "editor-components": "/editor-components/static-1.13475",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8636",
  "error-messaging-js": "/error-messaging-js/static-1.5363",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86300",
  "pictos": "/pictos/static-7.187",
  "react-transition-group": "/react-transition-group/static-2.67",
  "redux-request-state": "/redux-request-state/static-1.10813",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1911",
  "smart-content-core": "/smart-content-core/static-1.42914",
  "smart-content-lib": "/smart-content-lib/static-1.43567",
  "social-composer-lib": "/social-composer-lib/static-1.59776",
  "structured-content-lib": "/structured-content-lib/static-1.25657",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53707",
  "tinymce-copilot": "/tinymce-copilot/static-1.16898",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8115",
  "automation-ui-routing": "/automation-ui-routing/static-1.21660",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5776",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42564",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3360",
  "reporting-enablement": "/reporting-enablement/static-1.23496",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22150",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3186",
  "forms-ai-lib": "/forms-ai-lib/static-1.4580",
  "codemirror-dlb": "/codemirror-dlb/static-1.59153",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6602",
  "report-customization-components": "/report-customization-components/static-1.13624",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13476",
  "reporting-filters": "/reporting-filters/static-1.749",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2267"
}
};
